import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {PatchAPICommand} from '@drl/core/core.module';
import {environment} from '@drl/env/environment';

export class UpdatePrescriptionByIdCommand<T> extends PatchAPICommand<T> {
  constructor(
    apiService: ApiService,
    adapter: IAdapter<T>,
    presId: number,
  ) {
    super(
      apiService,
      adapter,
      `${environment.patientApiUrl}/prescriptions/${presId}`,
    );
  }
}
